import Base from "./Base";
import config from "../config";
import ActivityBridge from "./ActivityBridge";
import { catchError } from "../tools";

export type loginConfig = Partial<{
  includeBox: HTMLElement;
  host: string;
  platform: "web" | "h5";
  loginCallback: () => void;
  onClose: () => void;
  onDestroy: () => void;
}>;

export type SubmitParams = {
  account: string;
  purl: string;
  product: string;
  token: string;
  pwdUrl: string;
  errUrl: string;
};

function RequireOnReady() {
  return function (target: LoginBridge, propertyKey: string, descriptor: any) {
    const value = descriptor.value;
    descriptor.value = function (...args: any[]) {
      this.onReady(() => {
        value.apply(this, args);
      });
    };
  };
}

export default class LoginBridge extends Base {
  
  private activity: ActivityBridge;
  private config:loginConfig | undefined;
  private appHostReadyCallback: Function[] = [];

  static product: string = "hd"; //环境是活动
  static accountType: string = "Mail";

  constructor(config?: loginConfig) {
    super();
    this.config = config;
    this.activity = new ActivityBridge();
    this.initHandle();
  }

  @catchError("初始化异常")
  private async initHandle() {
    const isMaster = await this.activity.isMaster();
    if (isMaster) {
      this.appHostOnLoaded();
      return;
    }
    this.initUrsMoudle();
  }

  private initUrsMoudle() {
    if (!window?.MailLoginModule) {
      const scriptEl = document.createElement("script");
      scriptEl.src = config.loginModUrl as string;
      document.body.appendChild(scriptEl);
    }
  }

  public showLoginModule() {
    !window.MailLoginModule && this.initUrsMoudle();
    window.MailLoginModule.init({
      host: this.config?.host,
      platform: this.config?.platform,
      logincb: this.config?.loginCallback,
    });
    window.MailLoginModule.onClose = this.config?.onClose;
    window.MailLoginModule.onDestroy = this.config?.onDestroy;
    window.MailLoginModule.show();
    return window.MailLoginModule;
  }

  public hideLoginMoudle() {
    if(!!window.MailLoginModule) {
      window.MailLoginModule.hide();
    }
  }

  private appHostOnLoaded() {
    const loadedEvent = this.createEvent();
    const appHostLoaded = () => {
      // 解绑
      document.removeEventListener("appHostLoaded", appHostLoaded);
      this.invokeQueue(this.appHostReadyCallback);
      this.appHostReadyCallback = [];
    };

    const detect = () => {
      if (window.appHost) {
        document.dispatchEvent(loadedEvent);
      } else {
        // @ts-ignore
        window.appHostOnLoad = function () {
          document.dispatchEvent(loadedEvent);
        };
        document.addEventListener("appHostLoaded", appHostLoaded);
      }
    };

    if (this.isDomReady()) {
      detect();
    } else {
      document.addEventListener("DOMContentLoaded", detect);
    }
  }

  private stop(value: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(void 0);
      }, value || 0);
    });
  }
  // dom是否加载完毕
  private isDomReady() {
    return (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    );
  }
  // 主动触发回调调用
  private async invokeQueue(queue: Function[]) {
    if (queue && queue.length) {
      for (let i = 0; i < queue.length; i++) {
        const callback = queue[i];
        if (typeof callback === "function") {
          callback();
          await this.stop(100);
        }
      }
    }
  }
  // 创建事件触发
  private createEvent() {
    var loadedEvent = null;
    try {
      loadedEvent = new Event("appHostLoaded");
    } catch (e) {
      loadedEvent = document.createEvent("Event");
      loadedEvent.initEvent("appHostLoaded", true, true);
    }
    return loadedEvent;
  }
  // 加载完毕appHost
  public onReady(callback: Function) {
    if (this.isAppHostReady()) {
      callback && callback();
    } else {
      this.appHostReadyCallback.push(callback);
    }
  }
  // 是否准备就绪
  private isAppHostReady(): boolean {
    return window["appHost"];
  }
  // 自动登录邮箱
  @RequireOnReady()
  public async autoLoginEmail(uid: string, cb: Function) {
    console.log("开始登陆邮箱大师", window["appHost"]);
    window.Tongji.data("autoLogin_start");
    try {
      await window["appHost"].proxyInvoke(
        LoginBridge.product,
        "autoLogin",
        { account: uid, accountType: LoginBridge.accountType },
        (result: any) => {
          console.log("登陆token结果", result);
          window.Tongji.data("autoLogin_callback", result);
          if (!!result?.token) {
            const redirectUrl =
              window.location.origin +
              window.location.pathname +
              "?noStat=true";
            console.log("跳转链接", redirectUrl);
            this.submitLogin(
              {
                account: uid,
                purl: result.purl,
                token: result.token,
                product: LoginBridge.product,
                pwdUrl: redirectUrl,
                errUrl: redirectUrl,
              },
              () => {
                cb(result);
              }
            );

            return;
          }
          cb(result);
        }
      );
    } catch (e) {
      console.log("邮箱帐号自动登陆出错", e);
      cb(e);
    }
  }

  public static async getBaseInfo() {
    return new Promise(resolve => {
       window.appHost.invoke("getBaseInfo", {}, function (result: any){
         if(result?.appId) {
           resolve(result);
         }
       })
     });
   }

  private submitLogin(
    { account, purl, product, token, pwdUrl, errUrl }: SubmitParams,
    sucCallBack: Function | undefined
  ) {
    this.createForm();
    const loginForm = document.querySelector("#loginForm");
    if (!loginForm) return;
    (loginForm.querySelector('[name="uid"]') as HTMLInputElement).value =
      account;
    (loginForm.querySelector('[name="party"]') as HTMLInputElement).value =
      product;
    (loginForm.querySelector('[name="token"]') as HTMLInputElement).value =
      token;
    (loginForm.querySelector('[name="rurl"]') as HTMLInputElement).value =
      pwdUrl;
    (loginForm.querySelector('[name="errurl"]') as HTMLInputElement).value =
      errUrl;
    loginForm.setAttribute("action", purl);

    this.createIframe(() => {
      setTimeout(() => {

        window.Tongji.data("mmlogin_onload");

        sucCallBack && sucCallBack();
        const formContent = document.querySelector("#formContain");
        formContent && document.body.removeChild(formContent);
      }, 0);
    });
    (loginForm as HTMLFormElement).submit();
  }
  private buildForm() {
    return `<form action="" method="post" target="loginIframe" id="loginForm" style="display:none;">
              <input type="text" name="uid"><input type="text" name="party">
              <input type="text" name="token"><input type="text" name="rurl">
              <input type="text" name="errurl">
          </form>`;
  }

  private createForm() {
    const formContain = document.createElement("div"),
      form = this.buildForm();
    formContain.id = "formContain";
    formContain.style.display = "none";
    formContain.innerHTML = form;
    document.body.appendChild(formContain);
  }

  private createIframe(cb: () => void) {
    const iframe = document.createElement("iframe");
    iframe.name = "loginIframe";
    iframe.id = "loginIframe";
    iframe.style.display = "none";
    iframe.onload = () => cb();
    document.body.appendChild(iframe);
  }
}
